import { Stack } from "@mui/material";
import Phase1ActivityTimeline from "./Phase1ActivityTimeline";
import Phase1ArtifactBlocks from "./Phase1ArtifactBlocks";
import Phase1ResponseText from "./Phase1ResponseText";
import Phase1ResponseTail from "./Phase1ResponseTail";
import Phase1InlineResponseParts from './Phase1InlineResponseParts'
import { phase1MessageModel } from "./phase1MessageModel";
import { useLiveStreamEnter } from './useLiveStreamEnter'

/**
 * Artifacts above the prose that describes them; confirmation/connect cards
 * after it. Always prefer `responseParts` when present so a late card cannot
 * remount the text that already streamed.
 */
export default function Phase1MessageContent(props) {
  const { assistant, onAgentQuestionSelect } = props;
  const model = phase1MessageModel(assistant);
  const animateEnter = useLiveStreamEnter(model.streaming);
  return (
    <Stack sx={{ gap: 1.25, width: "100%" }}>
      <Phase1ActivityTimeline assistant={assistant} hasArtifacts={model.hasArtifacts} streaming={model.streaming} />
      {model.hasInlineParts ? (
        <Phase1InlineResponseParts
          parts={model.inlineParts}
          citations={model.citations}
          streaming={model.streaming}
          animateEnter={animateEnter}
        />
      ) : (
        <Phase1ResponseText text={model.text} citations={model.citations} streaming={model.streaming} />
      )}
      <Phase1ArtifactBlocks
        blocks={model.artifactBlocks}
        citations={model.citations}
        streaming={model.streaming}
        animateEnter={animateEnter}
      />
      <Phase1ResponseTail
        assistant={assistant}
        blocks={model.otherBlocks}
        citations={model.citations}
        streaming={model.streaming}
        animateEnter={animateEnter}
        onAgentQuestionSelect={onAgentQuestionSelect}
      />
    </Stack>
  );
}
